(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/banner-slider/assets/javascripts/banner-slider.js') >= 0) return;  svs.modules.push('/widgets/banner-slider/assets/javascripts/banner-slider.js');

'use strict';

svs.widget = svs.widget || {};
svs.widget.banner_slider = svs.widget.banner_slider || {};
svs.widget.banner_slider.init = svs.banner_groups.banner_slider.init;

 })(window);